module.exports = __webpack_public_path__ + "static/wpack/extracted/micfcc51768a5078c7d37f66846474d0972.svg";